import { CommandBase } from "../CommandBase.js";

export class HelpCommand extends CommandBase {
    async execute(args) {
        const helpHtml = this.contentManager.getHelpText();
        // Wrap in a div that enforces text color
        this.writeHTML(`<div class="text-primary">${helpHtml}</div>`);
    }
}